import apiHelper from '../utils/apiHelper';

export const workingGroupsService = {
    // Get all working groups
    getWorkingGroups: async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(`${apiUrl}/api/graph/getWorkingGroups`, {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await apiHelper.handleResponse(response);
            return await response.json();
        } catch (error) {
            console.error('Error fetching working groups:', error);
            throw error;
        }
    },

    // Get working groups schema
    getWorkingGroupsSchema: async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(`${apiUrl}/api/graph/getWorkingGroupsSchema`, {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await apiHelper.handleResponse(response);
            return await response.json();
        } catch (error) {
            console.error('Error fetching schema:', error);
            throw error;
        }
    },

    // Moving from apiHelper
    getWorkingGroupMembers: async (workingGroupId) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const authToken = await apiHelper.getAuthToken();
            const encodedGroupId = encodeURIComponent(workingGroupId);
            const response = await fetch(`${apiUrl}/api/graph/workinggroups/${encodedGroupId}/members`, {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await apiHelper.handleResponse(response);
            return await response.json();
        } catch (error) {
            console.error('Error fetching working group members:', error);
            throw error;
        }
    },

    createWorkingGroupMember: async (memberData) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(`${apiUrl}/api/graph/workinggroups/members`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(memberData)
            });
            
            await apiHelper.handleResponse(response);
            return await response.json();
        } catch (error) {
            console.error('Error creating working group member:', error);
            throw error;
        }
    },

    updateWorkingGroupMember: async (memberId, memberData) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(`${apiUrl}/api/graph/workinggroups/members/${memberId}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(memberData)
            });
            
            await apiHelper.handleResponse(response);
            return await response.json();
        } catch (error) {
            console.error('Error updating working group member:', error);
            throw error;
        }
    },

    updateWorkingGroup: async (workingGroupId, workingGroupData) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const authToken = await apiHelper.getAuthToken();
            const encodedGroupId = encodeURIComponent(workingGroupId);
            const response = await fetch(`${apiUrl}/api/graph/workinggroups/${encodedGroupId}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(workingGroupData)
            });
            
            await apiHelper.handleResponse(response);
            return await response.json();
        } catch (error) {
            console.error('Error updating working group:', error);
            throw error;
        }
    },

    createWorkingGroup: async (workingGroupData) => {
   
        try {
            // Map to SharePoint field names and ensure required fields have values
            const fields = {
                Title: workingGroupData.Title,
                WorkingGroupName: workingGroupData.WorkingGroupName,
                WorkingGroupType: workingGroupData.WorkingGroupType,
                SteeringGroupName: workingGroupData.SteeringGroupName || null,
                SteeringGroupType: workingGroupData.SteeringGroupType || null,
                StartDate0: workingGroupData.StartDate0 || null,
                EndDate0: workingGroupData.EndDate0 || null,
                PublishFlag: Boolean(workingGroupData.PublishFlag)
            };

 

            // Send to our backend API endpoint, not directly to SharePoint
            const response = await apiHelper.post('/api/graph/addWorkingGroup', fields);
            return response;
        } catch (error) {
            console.error('Error creating working group:', error);
            throw error;
        }
    },

    // Get working group documents
    getWorkingGroupDocuments: async (workingGroupId) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const authToken = await apiHelper.getAuthToken();
            const encodedGroupId = encodeURIComponent(workingGroupId);
            const response = await fetch(`${apiUrl}/api/graph/workinggroups/${encodedGroupId}/documents`, {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching working group documents:', error);
            throw error;
        }
    },

    // Get working group updates
    getWorkingGroupUpdates: async (workingGroupId) => {
        try {
          
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
        
            const endpoint = `${apiUrl}/api/graph/getWorkingGroupUpdates/${workingGroupId}`;
        
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(endpoint, {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();
   
            return data;
        } catch (error) {
            console.error('Error fetching working group updates:', {
                workingGroupId,
                error: error.message,
                stack: error.stack,
                response: error.response?.data
            });
            throw error;
        }
    },

    // Create working group update
    createWorkingGroupUpdate: async (updateData) => {
        try {
  
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const endpoint = `${apiUrl}/api/graph/createWorkingGroupUpdate`;
           
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(updateData)
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();
      
            return data;
        } catch (error) {
            console.error('Error creating working group update:', {
                updateData,
                error: error.message,
                stack: error.stack,
                response: error.response?.data
            });
            throw error;
        }
    },

    // Update existing working group update
    updateWorkingGroupUpdate: async (updateId, updateData) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const endpoint = `${apiUrl}/api/graph/updateWorkingGroupUpdate/${updateId}`;
          
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(updateData)
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error updating working group update:', error);
            throw error;
        }
    },

    deleteWorkingGroupUpdate: async (updateId) => {
        try {
          
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const endpoint = `${apiUrl}/api/graph/deleteWorkingGroupUpdate/${updateId}`;
        
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(endpoint, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('Error deleting working group update:', error);
            throw error;
        }
    },

    // Get TOR for a working group
    getWorkingGroupTOR: async (workingGroupId) => {
        try {
          
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const endpoint = `${apiUrl}/api/graph/getWorkingGroupTOR/${workingGroupId}`;
          
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(endpoint, {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('Error fetching TOR:', error);
            throw error;
        }
    },

    // Update TOR header
    updateWorkingGroupTORHeader: async (headerData) => {
        try {
        
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const endpoint = `${apiUrl}/api/graph/updateWorkingGroupTORHeader`;
          
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(headerData)
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error updating TOR header:', error);
            throw error;
        }
    },

    // Create new TOR objective
    createWorkingGroupTORObjective: async (objectiveData) => {
        try {
  
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const endpoint = `${apiUrl}/api/graph/createWorkingGroupTORObjective`;

            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objectiveData)
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();
           
            return data;
        } catch (error) {
            console.error('Error creating TOR objective:', error);
            throw error;
        }
    },

    // Update existing TOR objective
    updateWorkingGroupTORObjective: async (objectiveId, objectiveData) => {
        try {
           
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const endpoint = `${apiUrl}/api/graph/updateWorkingGroupTORObjective/${objectiveId}`;
         
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objectiveData)
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();
           
            return data;
        } catch (error) {
            console.error('Error updating TOR objective:', error);
            throw error;
        }
    },

    // Delete TOR objective
    deleteWorkingGroupTORObjective: async (objectiveId) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (!apiUrl) throw new Error('API URL is not defined');
            
            const endpoint = `${apiUrl}/api/graph/deleteWorkingGroupTORObjective/${objectiveId}`;
  
            
            const authToken = await apiHelper.getAuthToken();
            const response = await fetch(endpoint, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await apiHelper.handleResponse(response);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error deleting TOR objective:', error);
            throw error;
        }
    }
}; 